import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import formatNumbers  from 'util/formatNumbers';
import {Link} from 'react-router';
 import moment   from 'moment'

import {
    ADD_SELECTED_TRANSACTIONS, REMOVE_SELECTED_TRANSACTIONS
}  from "actions/actionTypes";
import config from  '../../../../config';

import {
    dateFormatter,
    getFieldByPathFormatter,
    priceFormatter,
    customFormatter,
    customTableSelect,
    actionsFormatter,
    historyDataFormatter,
    convertToHoursAndMinutes
} from 'util/Utils';
import HistoryDataModal   from 'shared/HistoryDataModal'
class ContractorTransactionListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            searchPlaceholder: '',
            historyDataModalVisible: false,
            currentRecord: {},
        };
    }

    componentDidMount() {
        setTimeout(function () {
            this.setState({'searchPlaceholder': 'trigger_table_render'});
        }.bind(this), 1000)
    }

    onRowSelect(row, isSelected, e) {
        var actionName = isSelected ? ADD_SELECTED_TRANSACTIONS : REMOVE_SELECTED_TRANSACTIONS;
        this.props.dispatchAction([row], actionName)
    }

    onAllRowSelect(isSelected, rows) {
        console.log('in all rows select', rows.length);
        var actionName = isSelected ? ADD_SELECTED_TRANSACTIONS : REMOVE_SELECTED_TRANSACTIONS;
        this.props.dispatchAction(rows, actionName)
    }

    customMultiSelect(props) {
        return customTableSelect(props, {
            table: this.refs.table,
            selectedRows: this.props.adminTransactions.selectedTransactions
        });
    }


    customLinkFormatter(cell, row) {

        if (row.SaleData && (row.SaleData['OrderID'] || row.SaleData['OrderNumber'])) {
            if (row.SaleData['OrderID'] && row.SaleData['OrderNumber']) {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>{row.SaleData['OrderNumber']}</a>
                );
            } else if (row.SaleData['OrderID']) {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>Order
                        ID</a>
                );
            } else {
                return (
                    <a target="_blank"
                       href={ config.getEnvironment().shopify.shopUrl + '/admin/orders.json?name=%23' + row.SaleData['OrderNumber'] + '&status=any'  }>#{row.SaleData['OrderNumber']}</a>
                );
            }
        } else {
            return ''
        }

    }

    showRemoveDialog(row) {
        this.props.showRemoveDialog(row)
    }

 

    hideModal() {
        this.setState({currentRecord: {}, historyDataModalVisible: false});
    }


    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = [ ];

        if (row.Status == 'PendingPayout' && row.Type =='WorkingTime') {
              menuItemsMap = [{onClick:(row)=>{
                  this.props.unsubmitTimeLogs(row);
              }, label: 'Un-submit'}];
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }
    timeLogsLinkFormatter(cell, row) {
        var PayoutRequestDate =  _.get(row, 'CustomData.PayoutRequestDate') ? moment(row.CustomData.PayoutRequestDate).format('MM/DD') : 'N/A'
                if (_.get(row.CustomData,'PayoutRequestID')){
                return <Link className=" underlineText" target="_blank"
                             to={'/admin/time-tracking?searchText='+encodeURIComponent(_.get(row.CustomData,'PayoutRequestID'))}>{PayoutRequestDate}</Link>
                }   else{
                    return PayoutRequestDate
                }

    }


    render() {
        const selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)
        }
        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref='table'
                                    data={this.props.adminTransactions.data}
                                    selectRow={ selectRowProp }
                                    remote={true}
                                    searchPlaceholder={this.state.searchPlaceholder}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } }>

                        <TableHeaderColumn width="50px" columnClassName={'break-word'} dataField="UserID.email"
                                           dataAlign="center"
                                           formatExtraData={ {path: ['UserID', 'firstName']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataSort={true}>First Name</TableHeaderColumn>
                        <TableHeaderColumn width="50px" columnClassName={'break-word'} dataField="UserID.email"
                                           dataAlign="center"
                                           formatExtraData={ {path: ['UserID', 'lastName']}}
                                           dataFormat={ getFieldByPathFormatter }
                                           dataSort={true}>Last Name</TableHeaderColumn>
                        <TableHeaderColumn width="40px" columnClassName={'break-word'} dataField="CustomData.TimeLogsStartTime"
                                           dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {
                                               path: ['CustomData', 'TimeLogsStartTime'] ,
                                               path2: ['CustomData', 'TimeLogsEndTime'] ,
                                               format: (TimeLogsStartTime,TimeLogsEndTime) => {
                                                   if (TimeLogsStartTime) {
                                                       return <div>
                                                         { moment(TimeLogsStartTime).format('MM/DD') + ' - ' + moment(TimeLogsEndTime).format('MM/DD')}
                                                        </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }}}

                                           dataSort={true}>Date Range</TableHeaderColumn>
                        {/*<TableHeaderColumn width="60px" columnClassName={'break-word'} dataField="CustomData.TimeLogsEndTime"*/}
                                                                                                           {/*dataAlign="center"*/}
                                                                                                           {/*dataFormat={ customFormatter }*/}
                                                                                                           {/*formatExtraData={ {*/}
                                                                                                               {/*path: ['CustomData', 'TimeLogsEndTime'] ,*/}
                                                                                                               {/*format: (TimeLogsEndTime) => {*/}
                                                                                                                   {/*if (TimeLogsEndTime) {*/}
                                                                                                                       {/*return <div>*/}
                                                                                                                           {/*<div>{  moment(TimeLogsEndTime).format('MM/DD')}</div>*/}
                                                                                                                           {/*<div>{  moment(TimeLogsEndTime).format('HH:mm')}</div>                                                       </div>*/}
                                                                                                                   {/*} else {*/}
                                                                                                                       {/*return ''*/}
                                                                                                                   {/*}*/}
                                                                                                               {/*}}}*/}

                                                                                                           {/*dataSort={true}>End Time</TableHeaderColumn>*/}
                        <TableHeaderColumn width="50px" columnClassName={'break-word'} dataField="CustomData.TotalTimeLogsDuration"
                                           dataAlign="center"
                                           dataFormat={ customFormatter }
                                           formatExtraData={ {
                                               path: ['CustomData', 'TotalTimeLogsDuration'] ,
                                               format: (TotalTimeLogsDuration) => {
                                                   if (TotalTimeLogsDuration) {

                                                       var timeLogsTotalTime = moment.duration(TotalTimeLogsDuration);
                                                        return <div>
                                                           <div>{convertToHoursAndMinutes(timeLogsTotalTime,{format:'minutes_in_percentage'})}</div>

                                                        </div>
                                                   } else {
                                                       return ''
                                                   }
                                               }}}

                                           dataSort={true}>Duration</TableHeaderColumn>

                        <TableHeaderColumn width="70px" dataAlign="center"
                                           dataField="Description" dataSort={true}>Description</TableHeaderColumn>
                        <TableHeaderColumn dataField="_id" isKey={true} hidden={true}
                                           autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>

                        <TableHeaderColumn width="30px" dataField='CustomData.HourlyRate' dataAlign="center"
                                           dataFormat={ priceFormatter } formatExtraData={ {
                            path: ['CustomData', 'HourlyRate']
                        }}
                                           dataSort={true}>Pay rate</TableHeaderColumn>
                        <TableHeaderColumn width="50px" dataField='ContractorID.Type' dataAlign="center"
                                           dataFormat={ getFieldByPathFormatter } formatExtraData={ {
                            path: ['ContractorID', 'Type']
                        }}
                                           dataSort={true}>Type</TableHeaderColumn>
                        <TableHeaderColumn width="40px"   dataAlign="center"      dataFormat={ customFormatter }
                                           formatExtraData={ {path:[  'getObject']  , format: (row)=> {
                                               var foundPaymentMethod =_.find(_.map(config.payoutMethodsMap, function (key, value) {
                                                   return {value: value, label: key}
                                               }), {'value':   _.get(row, ['ContractorID','PaymentMethod'])})
                                               return _.get(foundPaymentMethod,'label','')
                                           }}}
                                           dataField="ContractorID.PaymentMethod"  dataSort={true}  >Payment Method</TableHeaderColumn>
                        <TableHeaderColumn width="50px" dataFormat={ priceFormatter }
                                           formatExtraData={ {path: ['Amount']}  }
                                           dataAlign="center"
                                           dataField="Amount" dataSort={true}>Payment</TableHeaderColumn>
                        <TableHeaderColumn width="30px"  dataField="CustomData.PayoutRequestDate" dataAlign="center"  dataFormat={  this.timeLogsLinkFormatter }
                                           dataSort={true}>Requested At</TableHeaderColumn>

                        <TableHeaderColumn width="40px"  dataField="PaidAt" dataAlign="center" dataFormat={ dateFormatter }
                                           formatExtraData={ {'path': ['PaidAt'], 'format': 'MM/DD'} }
                                           dataSort={true}>Paid At</TableHeaderColumn>

                        <TableHeaderColumn width="40px" dataField='Status' dataAlign="center"
                                           dataFormat={ customFormatter } formatExtraData={ {
                            path: ['Status'], format: (value) => {
                                return _.startCase(value)
                            }
                        }}
                                           dataSort={true}>Status</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='MarketName'
                                           dataSort={true}>Location</TableHeaderColumn>

                        <TableHeaderColumn columnClassName={'actions-column'}
                                                                      dataAlign="center"
                                                                      dataFormat={ this.customActionsFormatter.bind(this) }
                    ></TableHeaderColumn>
                    </BootstrapTable>
                </div>

                <HistoryDataModal data={this.state.currentRecord} hideModal={this.hideModal.bind(this)}
                                show={this.state.historyDataModalVisible}></HistoryDataModal>
            </div>

        );
    }
}


export default ContractorTransactionListTable;
